<template>
  <!-- 后台管理系统顶部 -->
  <el-row>
    <el-col :span="4" class="tal">
      <div class="e-h-title" style="width:220px;">
        视频后台管理系统
        <!-- <img style="width:60px;height:100%;" src="../../assets/img/logo.jpg" /> -->
      </div>
    </el-col>
    <el-col class="tal" :span="4">
      <!-- <div class="e-h-title">视频后台管理系统</div> -->
      <!-- <el-tabs v-model="editableTabsValue2" type="card" closable @tab-remove="removeTab">
        <el-tab-pane
          v-for="(item, index) in editableTabs2"
          :key="item.name"
          :label="item.title"
          :name="item.name"
        >{{item.content}}</el-tab-pane>
      </el-tabs>-->
      <div class="backhome">
        <router-link to="/home">首页</router-link>
      </div>
    </el-col>
    <el-col class="tar" :span="16">
      <div class="e-h-logout">
        <a href="#" @click.prevent="logout">退出</a>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data: function () {
    return {
      editableTabsValue2: '2',
      editableTabs2: [
        {
          title: 'Tab 1',
          name: '1',
          content: 'Tab 1 content'
        },
        {
          title: 'Tab 2',
          name: '2',
          content: 'Tab 2 content'
        }
      ],
      tabIndex: 2
    }
  },
  methods: {
    logout () {
      this.$confirm('是否退出系统?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 清除保存的登录信息 token
          window.localStorage.removeItem('token')
          this.$store.state.userInfo = {}
          // 跳转回登录页面
          this.$router.push('/login')
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消退出"
          // });
        })
    },
    removeTab (targetName) {
      let tabs = this.editableTabs2
      let activeName = this.editableTabsValue2
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }

      this.editableTabsValue2 = activeName
      this.editableTabs2 = tabs.filter(tab => tab.name !== targetName)
    }
  }
}
</script>

<style scoped lang="scss">
/* 头部样式 */

.e-h-title {
  text-align: center;
  font-size: 20px;
  color: #fff;
  /* background-color: red; */
}

.e-h-logout {
  text-align: right;
  margin-right: 10px;
}

.e-h-logout a {
  color: #fff;
  text-decoration: none;
}
.backhome {
  font-size: 18px;
  a {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top/top.vue